<template>
    <modal
      title="Receivers"
      width="40"
      :showModal="showModal"
      @close-modal="closeModal"
    >
      <div class="delete-illustration-wrapper ">
        <img src="../icons/warningIcon.svg"  class="mt-3"/>
           <p class="mt-4 mb-3">Review the receiver's information and delivery instructions to ensure a smooth and timely shipment.</p>
           <div class="mt-2">
                <div class="have_package_container" v-for="(item, index) in extractedInfos" :key="index+'infos'">
                    <span>{{ item.name || item.contactName || ""}}</span>
                    <span class="books_number"> {{ (item.packagees || []).length || ''}} Package(s) <img class="ml-2" src="../icons/checkicon.svg"/></span>
                </div>
           </div>
           <div class="mt-3"></div>
           <hr/>
           <p class="mt-4 mb-3">No shipment(s) have been added for the following receivers:</p>

           <div class="mt-2">
            <div class="have_no_package_container" v-for="(item, index) in recieverWithoutpackage" :key="index+'noPackage'">
                <span>{{ item.name || item.contactName || ""}}</span>
                <span class="books_number">No package attached</span>
            </div>
       </div>

       <div class="actions">
        <p class="ext-darkBlue font-semibold cursor-pointer mr-5" @click="closeModal">
            Go back
        </p>
        <base-button
          text="Ignore & proceed"
          @click="contimueToPayment"
          :loading="loading"
        />
      </div>

      </div>
    </modal>
  </template>
  
  <script>
  // import Modal from "@/components/partials/Modal/index";
  export default {
    components: {
      // Modal,
    },
    props: {
      showModal: {
        type: Boolean,
        required: true,
        default: false,
      },
      extractedInfos:{
        required: false
      },
      receiversWithoutPackages:{
        required: false
      },
      contimueToPayment:{
         required: false
      }
    },
    watch: {
      showModal(){
        console.log(this.extractedInfos)
      }
    },
    computed: {
        recieverWithoutpackage(){
          return this.receiversWithoutPackages()
        }
    },
    data() {
      return {
        selectedModule: null,
        moduleOptions: [],
        loading: false,
        hasPackage: true
      };
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
    },
  };
  </script>
  
  <style scoped>
  .have_no_package_container{
    @apply flex items-center justify-between w-full mt-1 opacity-50; 
  }
  .have_package_container{
    @apply flex items-center justify-between w-full mt-1; 
  }
  .books_number{
    @apply inline-flex items-center;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    @apply items-center;
    padding: 1.5rem 0 1rem;
    padding-top: 6em;
  }
  .actions button {
    padding: 0.25rem 0.75rem;
    border-radius: 3px;
  }
  .cancel-btn {
    color: #f57a4d;
  }
  </style>
  